import React, { useState, useEffect, useContext } from "react";
import {
  Row,
  Col,
  Form,
  Input,
  Select,
  Typography,
  Button,
  Upload,
  Divider,
} from "antd";
import AddPhysicianModalWrapper from "../../modal/AddPhysicianModalWrapper";
import { CustomButton, CustomSecondaryButton } from "../physician_page/styled";
import { SpecilityContext } from "../../../context/SpecilityContext";
import styled from "styled-components";
import { notify } from "../../../utils/helper";
import { groupService } from "../../../services/Group";
import {
  UploadOutlined,
  DeleteOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import { extractToken } from "../../../utils/localStorage";
import { globalRoles } from "../../../utils/roles";
import { decyprtData } from "../../../utils/axios";
import { physicianService } from "../../../services/user";

const FormContainer = styled.div`
  max-height: 60vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 10px;
  width: 100%;

  /* Scrollbar styling */
  &::-webkit-scrollbar {
    width: 8px;
  }

  /* &::-webkit-scrollbar-track {
    background:rgb(138, 136, 136);
    border-radius: 10px;
  } */

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
  .ant-picker {
    background: var(--primary-bg);
    color: var(--primary-text-color);
    height: 40px;
    border-radius: 6px;
    border: 1px solid var(--border-color);

    &:hover {
      border-color: #8a3ef4;
    }
  }
  .ant-picker-input > input {
    color: var(--primary-text-color);
  }
  .ant-picker-suffix {
    color: var(--primary-text-color);
  }
  .ant-select-item-option-content {
    display: flex;
    justify-content: start;
    gap: 5px;
  }
  .data {
    border: 1px solid var(--border-color);
    color: var(--primary-text-color);
    padding: 7px 10px;
    border-radius: 6px;
    font-size: 16px;
    font-weight: 500;
  }
  .ant-input-group-addon .ant-select {
    margin: 0;
  }
  .ant-input-group-addon {
    padding: 0;
    border: none;
  }
  .ant-input-group-addon:first-child .ant-select .ant-select-selector {
    border-radius: 0;
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
  }
`;

const SectionContainer = styled.div`
  opacity: ${(props) => (props.show ? 1 : 0)};
  transform: translateY(${(props) => (props.show ? "0" : "10px")});
  transition: all 0.3s ease-in-out;
  pointer-events: ${(props) => (props.show ? "auto" : "none")};
  position: ${(props) => (props.show ? "relative" : "absolute")};
  width: 100%;

  ${(props) =>
    !props.show &&
    `
    height: 0;
    overflow: hidden;
  `}
`;

const SampleFileContainer = styled.div`
  background: var(--border-color);
  border: 1px solid var(--border-color);
  border-radius: 6px;
  padding: 12px 16px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .sample-text {
    color: var(--primary-text-color);
    font-size: 13px;
    margin: 0;
  }

  .download-link {
    color: #1890ff;
    font-size: 13px;
    cursor: pointer;
    text-decoration: underline;
    display: flex;
    align-items: center;
    gap: 4px;

    &:hover {
      color: #40a9ff;
    }
  }
`;

const GroupSection = styled.div`
  margin-top: 16px;
  padding: 20px;
  background: var(--primary-bg);
  border-radius: 8px;
  border: 1px solid var(--border-color);

  .ant-form-item-extra {
    color: var(--secondary-text-color);
  }
`;

const AddGroupModal = ({
  isOpen,
  setIsOpen,
  fetchGroups,
  selectedId,
  setSelectedId,
  isEdit,
  setIsEdit,
}) => {
  const [form] = Form.useForm();
  const user = extractToken();
  const { specialtyOptions } = useContext(SpecilityContext);
  const [loading, setLoading] = useState(false);
  const [showUploadInGroup, setShowUploadInGroup] = useState(false);
  const [isPreviewMode, setIsPreviewMode] = useState(false);
  const [previewData, setPreviewData] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [groupPhysicians, setGroupPhysicians] = useState(
    Array.from({ length: 10 }, (_, i) => ({ id: i + 1 }))
  );
  const [allPhysicianData, setAllPhysicianData] = useState([]);
  const [groupType, setGroupType] = useState("");

  const allPhysician = async () => {
    try {
      const res = await physicianService.getAll();
      setAllPhysicianData(res?.data?.results);
      // console.log("allPhysician:", res?.data);
    } catch (error) {}
  };
  useEffect(() => {
    allPhysician();
  }, []);

  const handleCreate = async (values) => {
    try {
      setLoading(true);
      if (isEdit) {
        const payload = {
          hospitalName: values.groupName,
        //   hospital: values.hospital,
          specialty: [values.specialties],
          description: values.description,
          type: values.type,
        };
        const res = await groupService.update(selectedId?._id, payload);
        notify("success", "Group updated successfully");
      } else {
        if (values.physicianFile && !isPreviewMode) {
          // First step: Preview the file
          const formData = new FormData();
          formData.append("file", values.physicianFile.file);
          const response = await physicianService.previewImport(formData); // Api Add when available.
          const previewPhysicians = decyprtData(response?.data);

          // Set preview data and enter preview mode
          setPreviewData(
            previewPhysicians?.users.map((physician, index) => ({
              ...physician,
              id: index + 1,
            }))
          );
          setIsPreviewMode(true);
          notify(
            "info",
            "File preview loaded. Please review and fix any duplicates before uploading."
          );
          return; // Don't close modal, stay in preview mode
        } else if (isPreviewMode) {
          // Second step: Actual upload after review
          // Filter out any physicians that might have been removed or have invalid data
          const validPhysicians = previewData.filter(
            (p) => p.name && p.email && p.specialty
          );
          if (validPhysicians.length === 0) {
            notify(
              "error",
              "Please ensure at least one physician has valid data (name, email, and specialty)."
            );
            setLoading(false);
            return;
          }

          // Send the modified preview data in the same format as preview response
          const uploadPayload = {
            users: validPhysicians.map(({ id, ...physician }) => physician),
            company: values.groupName || "Default Group",
            specialties: values.specialties,
            description: values.description,
          };

          const response = await physicianService.uploadFile(uploadPayload);
          notify(
            "success",
            `${validPhysicians.length} physicians uploaded successfully!`
          );
        } else {
          // Manual group creation
          const physiciansToCreate = groupPhysicians
            .map((physician) => {
              const physicianData = {
                name: values[`physician_${physician.id}_name`],
                email: values[`physician_${physician.id}_email`],
                specialty: values[`physician_${physician.id}_specialty`],
                boardMember:
                  user?.role === globalRoles.SUPERADMIN
                    ? values[`physician_${physician.id}_boardMember`] === "true"
                    : false,
              };
              return physicianData;
            })
            .filter((p) => p.name && p.email && p.specialty); // Only include physicians with required fields

          //Check for existing emails
          const existingEmails = allPhysicianData.map((physician) =>
            physician.email?.toLowerCase().trim()
          );
          const existingEmailsNormalized = existingEmails.map((email) =>
            email.toLowerCase().trim()
          );
          const duplicateEmail = physiciansToCreate.find((p) =>
            existingEmailsNormalized.includes(p.email.toLowerCase().trim())
          );
          if (duplicateEmail) {
            notify("error", `Email ${duplicateEmail.email} already exists.`);
            setLoading(false);
            return;
          }
          if (physiciansToCreate.length === 0) {
            notify(
              "error",
              "Please fill in all required fields for at least one physician."
            );
            setLoading(false);
            return;
          }

          // Prepare group payload
          const groupPayload = {
            company: values.groupName,
            specialties: [values.specialties],
            description: values.description,
            users: physiciansToCreate,
          };
          // console.log("groupPayload:", groupPayload);

          // Create group of physicians
          const response = await physicianService.uploadFile(groupPayload);
          notify(
            "success",
            `Group "${values.groupName}" with ${physiciansToCreate.length} physicians created successfully.`
          );
        }
      }
      onClose();
      fetchGroups();
      setIsEdit(false);
      setSelectedId([]);
    } catch (error) {
      setLoading(false);
    }
  };

  const onClose = () => {
    if (isEdit) {
      setIsEdit(false);
    }
    setIsOpen(false);
    setSelectedId([]);
    setPreviewData([]);
    setIsPreviewMode(false);
    setShowUploadInGroup(false);
    setFileList([]);
    form.resetFields();
  };

  useEffect(() => {
    if (isEdit) {
      form.setFieldsValue({
        groupName: selectedId?.hospitalName || "",
        description: selectedId?.description || "",
        specialties: selectedId?.specialty || "",
        type: selectedId?.type || ""
        // hospital: selectedId?.hospital || [],
      });
      setGroupType(selectedId?.type || "");
    } else {
      form.setFieldsValue({
        groupName: "",
        description: "",
        // hospital: [],
        specialties: [],
        type: "",
      });
      setGroupType("");
    }
  }, [selectedId, form, isEdit]);

  const uploadProps = {
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: (file) => {
      setFileList([...fileList, file]);
      return false;
    },
    fileList,
  };

  const downloadSampleFile = () => {
    const link = document.createElement("a");
    link.href = "/physician.xlsx";
    link.setAttribute("download", "physician.xlsx");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <AddPhysicianModalWrapper
      title={
        isEdit ? (
          <div className="row-flex flex-column">
            <h3 className="font-18 font-semibold text-primary mb-5">
              Update Group
            </h3>
            <span className="font-15 text-secondry">
              Edit the group’s information.
            </span>
          </div>
        ) : (
          <div className="row-flex flex-column">
            <h3 className="font-18 font-semibold text-primary mb-5">
              Add New Group
            </h3>
            <span className="font-15 text-secondry">
              Enter the details to add a new specialty group to the platform.
            </span>
          </div>
        )
      }
      show={isOpen}
      setShow={onClose}
      footer={null}
      width={700}
      keyClose={false}
      className="custom-detail-modal"
    >
      <Form form={form} layout="vertical" onFinish={handleCreate} onValuesChange={(changed) => { if (changed.type !== undefined) setGroupType(changed.type); }}>
        <FormContainer>
          <SectionContainer show={true}>
            <GroupSection>
              {/* Group Name Input */}
              <Row gutter={[24, 8]}>
                <Col span={12}>
                  <Form.Item
                    name="groupName"
                    label="Group Name"
                    rules={[
                      {
                        required: true,
                        message: "Please enter the group name!",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Enter Group Name (e.g., Cardiology Team, Surgery Department)"
                      size="large"
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    name="specialties"
                    label="Specialty"
                    rules={[
                      {
                        required: true,
                        message: "Please select the specialty!",
                      },
                    ]}
                  >
                    <Select
                      getPopupContainer={(triggerNode) =>
                        triggerNode.parentNode
                      }
                      placeholder="Select Specialty"
                      showSearch
                      style={{ width: "100%" }}
                      dropdownStyle={{
                        maxHeight: 200,
                        overflowY: "auto",
                        overflowX: "hidden",
                      }}
                      listHeight={160}
                      options={specialtyOptions}
                      size="large"
                      loading={loading}
                      filterOption={(input, option) =>
                        (option?.label ?? "")
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    name="type"
                    label="Group Type"
                    rules={[
                      {
                        required: true,
                        message: "Please select the type!",
                      },
                    ]}
                  >
                    <Select
                      getPopupContainer={(triggerNode) =>
                        triggerNode.parentNode
                      }
                      placeholder="Select Type"
                      showSearch
                      style={{ width: "100%" }}
                      dropdownStyle={{
                        maxHeight: 200,
                        overflowY: "auto",
                        overflowX: "hidden",
                      }}
                      listHeight={160}
                      // options={specialtyOptions}
                      size="large"
                      loading={loading}
                      filterOption={(input, option) =>
                        (option?.label ?? "")
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    >
                      <Select.Option value="clinical" style={{ color: '#000' }}>Clinical</Select.Option>
                      <Select.Option value="ccm" style={{ color: '#000' }}>CCM</Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    name="description"
                    label="Description"
                    rules={[
                      {
                        required: true,
                        message: "Please enter the description!",
                      },
                    ]}
                  >
                    <Input.TextArea
                      placeholder="Enter Description"
                      rows={4}
                      size="large"
                    />
                  </Form.Item>
                </Col>
              </Row>

              {/* Individual Physician Forms */}
              {!isEdit && (
                <div style={{ marginBottom: "20px" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                      marginBottom: "8px",
                    }}
                  >
                    <div>
                      <Typography.Text
                        strong
                        style={{
                          color: "var(--primary-text-color)",
                          marginBottom: "8px",
                          display: "block",
                        }}
                      >
                        {showUploadInGroup
                          ? "Upload Physician File"
                          : groupType === "ccm"
                          ? "Add Coordinator (Up to 10 Coordinator)"
                          : "Add Physicians (Up to 10 Physicians)"}
                      </Typography.Text>
                      <Typography.Text
                        style={{
                          color: "var(--secondary-text-color)",
                          marginBottom: "16px",
                          display: "block",
                          fontSize: "13px",
                        }}
                      >
                        {showUploadInGroup
                          ? isPreviewMode
                            ? "Review the data below. Users with red background are already registered - please update their email or remove them."
                            : "Upload a CSV or Excel file containing physician details for bulk creation."
                          : "Fill at least one complete physician. If you start filling a row, all fields in that row become required."}
                      </Typography.Text>
                    </div>
                    <Button
                      type={showUploadInGroup ? "default" : "primary"}
                      size="small"
                      icon={<UploadOutlined />}
                      onClick={() => setShowUploadInGroup(!showUploadInGroup)}
                      style={{
                        marginTop: "2px",
                        fontWeight: "500",
                        color: "var(--primary-text-color)",
                      }}
                    >
                      {showUploadInGroup ? "Manual Entry" : "Upload File"}
                    </Button>
                  </div>

                  {!showUploadInGroup ? (
                    <>
                      {/* Sticky Header */}
                      <div
                        style={{
                          position: "sticky",
                          top: "0",
                          zIndex: 10,
                          background: "var(--secondary-bg)",
                          border: "1px solid var(--border-color)",
                          borderRadius: "4px 4px 0 0",
                          padding: "8px",
                          marginBottom: "0",
                        }}
                      >
                        <Row gutter={[8, 0]} align="middle">
                          <Col span={1}>
                            <div
                              style={{
                                fontSize: "13px",
                                fontWeight: "600",
                                color: "var(--primary-text-color)",
                                textAlign: "center",
                              }}
                            >
                              #
                            </div>
                          </Col>
                          <Col span={7}>
                            <div
                              style={{
                                fontSize: "13px",
                                fontWeight: "600",
                                color: "var(--primary-text-color)",
                              }}
                            >
                              Full Name
                            </div>
                          </Col>
                          <Col span={8}>
                            <div
                              style={{
                                fontSize: "13px",
                                fontWeight: "600",
                                color: "var(--primary-text-color)",
                              }}
                            >
                              Email
                            </div>
                          </Col>
                          <Col span={8}>
                            <div
                              style={{
                                fontSize: "13px",
                                fontWeight: "600",
                                color: "var(--primary-text-color)",
                              }}
                            >
                              Specialty
                            </div>
                          </Col>
                        </Row>
                      </div>

                      {/* Scrollable Rows */}
                      <div
                        style={{
                          maxHeight: "300px",
                          overflowY: "auto",
                          border: "1px solid var(--border-color)",
                          borderTop: "none",
                          borderRadius: "0 0 4px 4px",
                        }}
                      >
                        {groupPhysicians.map((physician, index) => (
                          <div
                            key={physician.id}
                            style={{
                              padding: "8px",
                              borderBottom:
                                index < groupPhysicians.length - 1
                                  ? "1px solid var(--border-color)"
                                  : "none",
                              background: "var(--primary-bg)",
                              "&:hover": { background: "var(--secondary-bg)" },
                            }}
                          >
                            <Row gutter={[8, 0]} align="middle">
                              <Col span={1}>
                                <div
                                  style={{
                                    fontSize: "13px",
                                    fontWeight: "500",
                                    color: "var(--secondary-text-color)",
                                    textAlign: "center",
                                  }}
                                >
                                  {index + 1}
                                </div>
                              </Col>

                              <Col span={7}>
                                <Form.Item
                                  name={`physician_${physician.id}_name`}
                                  rules={[
                                    ({ getFieldValue }) => ({
                                      validator(_, value) {
                                        // Skip validation if not in group mode or showing upload
                                        return Promise.resolve();

                                        //   const email = getFieldValue(
                                        //     `physician_${physician.id}_email`
                                        //   );
                                        //   const specialty = getFieldValue(
                                        //     `physician_${physician.id}_specialty`
                                        //   );

                                        //   // If any field is filled, all fields are required for this physician
                                        //   if (email || specialty) {
                                        //     if (!value) {
                                        //       return Promise.reject(
                                        //         new Error(
                                        //           "Name is required when email or specialty is provided!"
                                        //         )
                                        //       );
                                        //     }
                                        //   }

                                        //   // If this is the first physician and no other physicians are filled, require at least this one
                                        //   if (physician.id === 1) {
                                        //     const allValues = form.getFieldsValue();
                                        //     const hasAnyOtherPhysician =
                                        //       groupPhysicians
                                        //         .slice(1)
                                        //         .some(
                                        //           (p) =>
                                        //             allValues[
                                        //               `physician_${p.id}_name`
                                        //             ] ||
                                        //             allValues[
                                        //               `physician_${p.id}_email`
                                        //             ] ||
                                        //             allValues[
                                        //               `physician_${p.id}_specialty`
                                        //             ]
                                        //         );

                                        //     if (
                                        //       !hasAnyOtherPhysician &&
                                        //       !value &&
                                        //       !email &&
                                        //       !specialty
                                        //     ) {
                                        //       return Promise.reject(
                                        //         new Error(
                                        //           "At least one physician is required!"
                                        //         )
                                        //       );
                                        //     }
                                        //   }

                                        //   return Promise.resolve();
                                      },
                                    }),
                                  ]}
                                  style={{ marginBottom: "0" }}
                                >
                                  <Input
                                    placeholder="Enter Full Name"
                                    size="small"
                                  />
                                </Form.Item>
                              </Col>

                              <Col span={8}>
                                <Form.Item
                                  name={`physician_${physician.id}_email`}
                                  rules={[
                                    {
                                      type: "email",
                                      message: "Please enter a valid email!",
                                    },
                                    ({ getFieldValue }) => ({
                                      validator(_, value) {
                                        // Skip validation if not in group mode or showing upload
                                        return Promise.resolve();

                                        //   const name = getFieldValue(
                                        //     `physician_${physician.id}_name`
                                        //   );
                                        //   const specialty = getFieldValue(
                                        //     `physician_${physician.id}_specialty`
                                        //   );

                                        //   // If any field is filled, all fields are required for this physician
                                        //   if (name || specialty) {
                                        //     if (!value) {
                                        //       return Promise.reject(
                                        //         new Error(
                                        //           "Email is required when name or specialty is provided!"
                                        //         )
                                        //       );
                                        //     }
                                        //   }

                                        //   return Promise.resolve();
                                      },
                                    }),
                                  ]}
                                  style={{ marginBottom: "0" }}
                                >
                                  <Input
                                    placeholder="Email address"
                                    size="small"
                                  />
                                </Form.Item>
                              </Col>

                              <Col span={8}>
                                <Form.Item
                                  name={`physician_${physician.id}_specialty`}
                                  rules={[
                                    ({ getFieldValue }) => ({
                                      validator(_, value) {
                                        // Skip validation if not in group mode or showing upload
                                        return Promise.resolve();

                                        //   const name = getFieldValue(
                                        //     `physician_${physician.id}_name`
                                        //   );
                                        //   const email = getFieldValue(
                                        //     `physician_${physician.id}_email`
                                        //   );

                                        //   // If any field is filled, all fields are required for this physician
                                        //   if (name || email) {
                                        //     if (!value) {
                                        //       return Promise.reject(
                                        //         new Error(
                                        //           "Specialty is required when name or email is provided!"
                                        //         )
                                        //       );
                                        //     }
                                        //   }

                                        //   return Promise.resolve();
                                      },
                                    }),
                                  ]}
                                  style={{ marginBottom: "0" }}
                                >
                                  <Select
                                    getPopupContainer={(triggerNode) =>
                                      triggerNode.parentNode
                                    }
                                    placeholder="Select Specialty"
                                    showSearch
                                    size="small"
                                    style={{ width: "100%" }}
                                    dropdownStyle={{
                                      maxHeight: 200,
                                      overflowY: "auto",
                                      overflowX: "hidden",
                                    }}
                                    listHeight={160}
                                    options={specialtyOptions}
                                    //   loading={loading}
                                    filterOption={(input, option) =>
                                      (option?.label ?? "")
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                    }
                                  />
                                </Form.Item>
                              </Col>
                            </Row>
                          </div>
                        ))}
                      </div>
                    </>
                  ) : (
                    /* Upload Section */
                    <>
                      {!isPreviewMode && (
                        <>
                          <SampleFileContainer>
                            <Typography.Text className="sample-text">
                              Download our sample template to get started.
                            </Typography.Text>
                            <span
                              className="download-link"
                              onClick={downloadSampleFile}
                            >
                              <DownloadOutlined />
                              Download Sample
                            </span>
                          </SampleFileContainer>

                          <Row gutter={[24, 16]}>
                            <Col span={24}>
                              <Form.Item
                                name="physicianFile"
                                label="Upload Physician Details"
                                extra="Supported formats: CSV, XLSX, XLS. Maximum file size: 10MB. This will override the manually entered physicians above."
                              >
                                <Upload
                                  {...uploadProps}
                                  accept=".csv,.xlsx,.xls"
                                >
                                  <Button
                                    className="text-primary"
                                    icon={<UploadOutlined />}
                                    size="large"
                                    block
                                  >
                                    Click to Upload File
                                  </Button>
                                </Upload>
                              </Form.Item>
                            </Col>
                          </Row>
                        </>
                      )}

                      {isPreviewMode && previewData.length > 0 && (
                        <div style={{ marginBottom: "20px" }}>
                          {/* Sticky Header */}
                          <div
                            style={{
                              position: "sticky",
                              top: "0",
                              zIndex: 10,
                              background: "var(--secondary-bg)",
                              border: "1px solid var(--border-color)",
                              borderRadius: "4px 4px 0 0",
                              padding: "8px",
                              marginBottom: "0",
                            }}
                          >
                            <Row gutter={[8, 0]} align="middle">
                              <Col span={1}>
                                <div
                                  style={{
                                    fontSize: "13px",
                                    fontWeight: "600",
                                    color: "var(--primary-text-color)",
                                    textAlign: "center",
                                  }}
                                >
                                  #
                                </div>
                              </Col>
                              <Col span={6}>
                                <div
                                  style={{
                                    fontSize: "13px",
                                    fontWeight: "600",
                                    color: "var(--primary-text-color)",
                                  }}
                                >
                                  Full Name
                                </div>
                              </Col>
                              <Col span={7}>
                                <div
                                  style={{
                                    fontSize: "13px",
                                    fontWeight: "600",
                                    color: "var(--primary-text-color)",
                                  }}
                                >
                                  Email
                                </div>
                              </Col>
                              <Col span={6}>
                                <div
                                  style={{
                                    fontSize: "13px",
                                    fontWeight: "600",
                                    color: "var(--primary-text-color)",
                                  }}
                                >
                                  Specialty
                                </div>
                              </Col>
                              <Col span={3}>
                                <div
                                  style={{
                                    fontSize: "13px",
                                    fontWeight: "600",
                                    color: "var(--primary-text-color)",
                                  }}
                                >
                                  BM
                                </div>
                              </Col>
                              <Col span={1}>
                                <div
                                  style={{
                                    fontSize: "13px",
                                    fontWeight: "600",
                                    color: "var(--primary-text-color)",
                                    textAlign: "center",
                                  }}
                                ></div>
                              </Col>
                            </Row>
                          </div>

                          {/* Preview Data Rows */}
                          <div
                            style={{
                              maxHeight: "400px",
                              overflowY: "auto",
                              border: "1px solid var(--border-color)",
                              borderTop: "none",
                              borderRadius: "0 0 4px 4px",
                            }}
                          >
                            {previewData.map((physician, index) => (
                              <div
                                key={physician.id}
                                style={{
                                  padding: "8px",
                                  borderBottom:
                                    index < previewData.length - 1
                                      ? "1px solid var(--border-color)"
                                      : "none",
                                  background: physician.alreadyRegistered
                                    ? "#fee"
                                    : "var(--primary-bg)",
                                  "&:hover": {
                                    background: physician.alreadyRegistered
                                      ? "#fdd"
                                      : "var(--secondary-bg)",
                                  },
                                }}
                              >
                                <Row gutter={[8, 0]} align="middle">
                                  <Col span={1}>
                                    <div
                                      style={{
                                        fontSize: "13px",
                                        fontWeight: "500",
                                        color: "var(--secondary-text-color)",
                                        textAlign: "center",
                                      }}
                                    >
                                      {index + 1}
                                    </div>
                                  </Col>

                                  <Col span={6}>
                                    <Input
                                      size="small"
                                      value={physician.name}
                                      onChange={(e) => {
                                        const newData = [...previewData];
                                        newData[index].name = e.target.value;
                                        setPreviewData(newData);
                                      }}
                                      style={{
                                        border: physician.alreadyRegistered
                                          ? "1px solid #ff4d4f"
                                          : "1px solid var(--border-color)",
                                      }}
                                    />
                                  </Col>

                                  <Col span={7}>
                                    <Input
                                      size="small"
                                      value={physician.email}
                                      onChange={(e) => {
                                        const newData = [...previewData];
                                        newData[index].email = e.target.value;
                                        newData[
                                          index
                                        ].alreadyRegistered = false; // Reset registration status when email changes
                                        setPreviewData(newData);
                                      }}
                                      style={{
                                        border: physician.alreadyRegistered
                                          ? "1px solid #ff4d4f"
                                          : "1px solid var(--border-color)",
                                      }}
                                    />
                                  </Col>

                                  <Col span={6}>
                                    <Select
                                      size="small"
                                      value={physician.specialty}
                                      onChange={(value) => {
                                        const newData = [...previewData];
                                        newData[index].specialty = value;
                                        setPreviewData(newData);
                                      }}
                                      style={{ width: "100%" }}
                                      options={specialtyOptions}
                                    />
                                  </Col>

                                  <Col span={3}>
                                    <Select
                                      size="small"
                                      value={
                                        physician.boardMember ? "true" : "false"
                                      }
                                      onChange={(value) => {
                                        const newData = [...previewData];
                                        newData[index].boardMember =
                                          value === "true";
                                        setPreviewData(newData);
                                      }}
                                      style={{ width: "100%" }}
                                      options={[
                                        { label: "Yes", value: "true" },
                                        { label: "No", value: "false" },
                                      ]}
                                    />
                                  </Col>

                                  <Col span={1}>
                                    <div
                                      onClick={() => {
                                        const newData = previewData.filter(
                                          (_, i) => i !== index
                                        );
                                        setPreviewData(newData);
                                      }}
                                      style={{
                                        color: "#ff4d4f",
                                        cursor: "pointer",
                                        fontSize: "16px",
                                      }}
                                    >
                                      <DeleteOutlined />
                                    </div>
                                  </Col>
                                </Row>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </div>
              )}
            </GroupSection>
          </SectionContainer>
        </FormContainer>

        <Divider style={{ margin: "20px 0" }} />

        <Row>
          <Col span={24} className="d-flex justify-end gap-12">
            <CustomSecondaryButton onClick={onClose} style={{ marginLeft: 10 }}>
              Cancel
            </CustomSecondaryButton>
            <CustomButton htmlType="submit">
              {loading
                ? "Processing..."
                : isEdit
                ? "Update Group"
                : "Add Group"}
            </CustomButton>
          </Col>
        </Row>
      </Form>
    </AddPhysicianModalWrapper>
  );
};

export default AddGroupModal;
